export class BrowserNavigation {
  public static userCameWithBrowserBackOrForward(): boolean {
    return (
      window.performance &&
      window.performance.navigation.type ===
        window.performance.navigation.TYPE_BACK_FORWARD
    );
  }
}
